import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/predictive_maintenance/schedule";

export class EditPredictiveMaintenanceScheduleCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: EditPredictiveMaintenanceScheduleReqData;

    constructor(payload: EditPredictiveMaintenanceScheduleReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class EditPredictiveMaintenanceScheduleReqData {
    public predictionScheduleTime: string = null;
    public trainingScheduleDays: Number = null;
    public trainingScheduleTime: string = null;

    constructor(newSchedule: any) {
        this.predictionScheduleTime = newSchedule.predictionScheduleTime;
        this.trainingScheduleDays = newSchedule.trainingScheduleDays;
        this.trainingScheduleTime = newSchedule.trainingScheduleTime;
    }
}
